const consultingcategory = {
    getlist: 'consultingcategory/getlist-by-admin',
    add: 'consultingcategory/add',
    update: 'consultingcategory/update',
    remove: 'consultingcategory/remove',
    get: 'consultingcategory/get',
    getall: 'consultingcategory/getall-by-admin',
    clearcache: 'consultingcategory/clear-cache',
}
export default consultingcategory
